import { Box, InputAdornment, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { useInputWithDebounce } from 'customHook/useInputWithDebounce';
import DropDown from './Dropdown';
import { muiStyles } from './muiStyles';

const GlobalSearch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const searchRef = useRef<HTMLDivElement | null>(null);

  const { value, debouncedValue, handleChange, clearInput } = useInputWithDebounce('', 500);

  const handleFocus = () => {
    setIsOpen(true);
  };

  const handleCloseSearch = () => setIsOpen(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box sx={muiStyles.searchContainer} ref={searchRef} onClick={handleFocus}>
      <TextField
        variant='outlined'
        placeholder='Search'
        value={value}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <img
                width={20}
                height={20}
                src={'/assets/search-icon.svg'}
                alt='search-project'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}
              />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position='end' onClick={clearInput}>
              <img
                width={20}
                height={20}
                src={'/assets/clear-input.svg'}
                alt='clear-input'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}
              />
            </InputAdornment>
          ),
        }}
        sx={muiStyles.input}
      />
      {isOpen && <DropDown searchValue={debouncedValue} handleCloseSearch={handleCloseSearch} />}
    </Box>
  );
};

export default GlobalSearch;
